<template>
  <div class="open-list-box">
    <div class="open-list">
      <!--标题栏-->
      <app-header title="开通申请列表" @goback="goBack">
        <div slot="tips" @click="goToOpen">
          <div class="open-text">功能开通</div>
        </div>
      </app-header>
      
        <!-- 状态切换 -->
        <div class="state-box" @click="openStatus">
          <span>{{currentStatus.text}}</span><i class="iconfont iconxiala"></i>
        </div>
        <ul class="list-box">
          <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
          <li v-for="(item, index) in orderList" :key="index">
            <checkbox v-model="checkedIds" class="list-checkbox" :class="{'disable-checkbox': item.status !== 2}" :value="item.id" :disabled="item.status !== 2"></checkbox>
            <div class="list-right">
              <div class="list-title">{{ item.productName }}</div>
              <div class="list-message">{{ item.moduleName }}</div>
              <div class="list-time">{{ _formatTime(item.applyTime) }}</div>
              <div class="list-status">{{ _caclStatusText(item.status) }}</div>
            </div>
          </li>
          </pull-to>
        </ul>
      
    </div>
    <Button class="submit-btn" @click="payOpen">缴费开通</Button>
  </div>
</template>

<script>
import PullTo from 'vue-pull-to';
import { commonMixin } from 'common/js/mixin';
import { Checkbox } from 'vue-checkbox-radio';
import moment from 'moment';
import apis from 'api/index';
import { mapMutations, mapGetters, mapState } from 'vuex';

export default {
  mixins: [commonMixin],
  components: {
    PullTo,
    Checkbox,
  },
  data() {
    return {
      status: 0, // 绑定popup的status
      statusList: [ // 所有状态
        {text: '全部状态', value: 0},
        {text: '申请中', value: 1}, 
        {text: '已通过', value: 2}, 
        {text: '开通失败', value: 3}, 
        {text: '已取消', value: 4}, 
        {text: '开通成功', value: 5}
      ],
      // bottomConfig: BOTTOM_DEFAULT_CONFIG,
      orderList: [],  // 申请列表
      orderPageNumber: 1,
      orderPageSize: 10,
      orderTotal: null,
      checkedIds: [], // 选中缴费的数组
    }
  },
  computed: {
    currentStatus() {
      return this.statusList.filter(item => item.value === this.status)[0]
    },
    // 用来控制是否启用下拉刷新
    isLoadAll() {
      return Boolean(this.orderTotal > this.orderPageNumber * this.orderPageSize)
    },
    // 已选择的list集合
    selectList() {
      return this.orderList.filter(item => {
        for(let i = 0; i < this.checkedIds.length; i++) {
          if(item.id === this.checkedIds[i]) {
            return item
          }
        }
      });
    },
    currentStatusIndex() {
      return this.statusList.findIndex(item => item.value === this.status);
    },
    ...mapState(['payList']),
    ...mapGetters(['userAllInfo'])
  },
  created() {
    if(this.payList.length !== 0) {
      this.checkedIds = this.payList.map(item => item.id);
    }
    let status = this.$route.query.status;
    if(status !== undefined) {
      this.status = Number(status);
    }
    this.fetchServiceList(this.status);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToOpen() {
      this.$router.push({name: 'open-module'});
    },
    // 打开选择状态列表
    openStatus() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '状态选择',
          data: [this.statusList],
          selectedIndex: [this.currentStatusIndex],
          onSelect: this.changeStatus,
        })
      }
      this.picker.show();
    },
    // 触发
    changeStatus(status) {
      if(this.status === status[0]) {
        return false;
      }
      this.status = status[0];
      this.orderPageNumber = 1;
      this.orderList = [];
      this.fetchServiceList(this.status);
    },
    loadmore(loaded) {
      if(this.orderTotal <= this.orderPageNumber * this.orderPageSize) {
        return false;
      }
      this.orderPageNumber +=1;
      this.fetchServiceList().then(res => {
        loaded('done');
      });
    },
    payOpen() {
      if(this.checkedIds.length === 0) {
        this.showToast('请选择需开通的业务', 'warn');
        return false;
      }

      this.setPayList(this.selectList);
      this.$router.push({name: 'charge-pay'});
    },
    async fetchServiceList(status) {
      let params = {};
      params.groupId = this.userAllInfo.enterprise.id;
      params.no = this.orderPageNumber;
      params.limit = this.orderPageSize;
      params.status = status === 0 ? null : status;
      const res = await apis.ordersModuleOrder(params);
      if(res) {
        this.orderList = this.orderList.concat(res.records);
        this.orderTotal = res.total;
      }
    },
    _formatTime(time) {
      return moment(time).format('YYYY年MM月DD日');
    },
    _caclStatusText(status) {
      return this.statusList.filter(item => item.value === status)[0].text; 
    },
    ...mapMutations(['setPayList'])
  }
}
</script>


<style lang="scss" scoped  src="./open.scss"></style>

<style lang="scss">
input {
  outline: none;
}
.checkbox-component > input + label > .input-box,
.radio-component > input + label > .input-box {
  border-color: #D9D9D9 !important;
  background: #fff !important;
  width: 18px !important;
  height: 18px !important;
}
.checkbox-component > input + label > .input-box > .input-box-tick > path {
  stroke: #ff9900 !important;
}
.radio-component > input + label > .input-box > .input-box-circle {
  background: #fff !important;
}

.disable-checkbox > input + label > .input-box,
.radio-component > input + label > .input-box {
  border-color: #D9D9D9 !important;
  background: #D9D9D9 !important;
  width: 18px !important;
  height: 18px !important;
}
</style>
